"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isPaused = () => { var _a; return ((_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.contains("paused")) || false; };
exports.default = isPaused;
